<template>
  <div>
    <v-flex text-md-center v-if="loading">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-flex>
    <div v-else>
      <ResultsUser v-if="getResultUser" :results="getResultUser" :headers="headers_user"/>
      <br>

      <ResultsPost 
        v-if="getResultPost" 
        :results="getResultPost" 
        :headers="$vuetify.breakpoint.smAndDown ? headersPostMobile : headersPost"
      />
      <br>
      
      <results-menu v-if="getResultMenu" :results="getResultMenu" :headers="headers_menu"/>
      <br>
      <results-benefit v-if="getResultBenefit" :results="getResultBenefit" :headers="headers_benefit"/>
    
      <div v-if="getResultUser && getResultPost && getResultMenu && getResultBenefit">
        <div v-if="getResultUser.length < 1 && getResultPost.length < 1 && getResultMenu.length < 1 && getResultBenefit < 1">
          <v-layout slot="no-results">
            <v-flex sm12>
              <v-card height="400px">
                <v-layout align-center justify-center row wrap fill-height>
                  <v-flex
                    sm12
                    class="text-29-security text-md-center font-weight-bold"
                    style="color: #525252"
                  >No hay resultados.</v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import ResultsUser from "./ResultsUser";
import ResultsPost from "./ResultsPost";
import ResultsMenu from "./ResultsMenu";
import ResultsBenefit from "./ResultsBenefit";

export default {
  components: { ResultsUser, ResultsPost, ResultsMenu, ResultsBenefit },
  computed: {
    ...mapState("user", ["selected_user"]),
    ...mapGetters("searchs", [
      "getResultUser",
      "getResultPost",
      "getResultMenu",
      "getResultBenefit"
    ])
  },
  data() {
    return {
      loading: true,
      interval: {},
      headers_user: [
        { text: "Imagen", value: "image", width: "10%" },
        { 
          text: "Nombre", 
          value: "full_name", 
          width: "40%", 
          class: `${this.$vuetify.breakpoint.smAndDown ? 'width-header-mobile' : ''}`
        },
        { text: "Correo", value: "email", width: "40%" },
        { text: "Anexo", value: "annexed", width: "10%" }
      ],
      headersPost: [
        {
          text: "Título",
          align: "left",
          sortable: false,
          value: "title"
        },
        { text: "Categoría", value: "post_type" },
        { text: "Contenido", value: "content" },
        { text: "Publicado el", value: "published_at" }
      ],
      headersPostMobile: [
        {
          text: "Título",
          align: "left",
          sortable: false,
          value: "title"
        },
        { text: "Publicado el", align: "right", value: "published_at_mobile" }
      ],
      headers_menu: [
        {
          text: "Título",
          align: "left",
          sortable: false,
          value: "title"
        },
        { text: "Descripción", value: "description" },
        { text: "Enlace", value: "link" }
      ],
      headers_benefit: [
        {
          text: "Título",
          align: "left",
          sortable: false,
          value: "title"
        },
        { text: "Enlace", value: "url" }
      ]
    };
  },
  mounted() {
    if (this.$route.params.query.length < 3) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        title: "La búsqueda debe contener al menos 3 caracteres.",
        confirmButtonText: "Entendido"
      }).then(() => this.$router.push("/"));
    } else this.fetchResult(this.$route.params.query);

    this.interval = setInterval(() => {
      if (this.getResultUser || this.getResultPost || this.getResultMenu) {
        clearInterval(this.interval);
        return (this.loading = false);
      }
    }, 1000);
  },
  beforeDestroy(){
    clearInterval(this.interval);
  },
  methods: {
    ...mapActions("searchs", ["fetchResult"]),
    ...mapMutations("searchs", ["setResult"]),
    message() {
      return `Mostrando resultados para ${this.$route.params.query}`;
    }
  }
};
</script>

<style>
table.v-table tbody td {
  font-size: 16px;
}

table.v-table thead th {
  font-size: 16px;
}

.v-datatable__actions {
  font-size: 16px;
}

@media screen and (min-width: 300px) and (max-width: 425px) {
  table.v-table tbody td {
    font-size: 14px !important;
  }
}
</style>